import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import { KeyboardArrowDownOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import { useWarehouseContext } from "../../contexts"

import type { WarehouseAreaFeeOutput } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

interface WarehouseFeeItem {
  id: string
  type: string
  amount?: number | null
}

const WarehouseFees: FC = () => {
  const warehouse = useWarehouseContext()
  const [isExpanded, setIsExpanded] = useState(true)
  const fees: WarehouseFeeItem[] = [
    {
      id: "monthly-accrual",
      type: "Monthly Accrual",
      amount: warehouse.monthlyAccrualFee,
    },
    {
      id: "warehouse-inbound",
      type: "Warehouse Inbound",
      amount: warehouse.inboundFee,
    },
    {
      id: "warehouse-outbound",
      type: "Warehouse Outbound",
      amount: warehouse.outboundFee,
    },
    ...(warehouse.miscellaneousFees ?? []).map((fee: WarehouseAreaFeeOutput) => ({
      id: fee.warehouseAreaFeeId,
      type: fee.type,
      amount: fee.amount,
    })),
  ]

  return (
    <Accordion
      elevation={0}
      slotProps={{ heading: { component: "h2" } }}
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      <AccordionSummary expandIcon={<KeyboardArrowDownOutlined />}>
        <Typography variant='subtitle1' component='span'>
          Warehouse Fees
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Charge Type</TableCell>
              <TableCell>Charge Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fees.map((fee) => (
              <TableRow key={fee.id}>
                <TableCell className='w-[13.375rem]' data-test={`warehouse-fee-type-${fee.id}`}>
                  {fee.type}
                </TableCell>
                <TableCell data-test={`warehouse-fee-amount-${fee.id}`}>
                  {fee.amount !== null && fee.amount !== undefined ? `$${formatNumber(fee.amount)}` : ""}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  )
}

export default WarehouseFees
